import { permissionService } from 'shared/services';

import CompanyList from '../containers/CompanyList/CompanyList.container';
import CompanyDetail from '../containers/CompanyDetail/CompanyDetail.container';
import CompanyRegister from '../containers/CompanyRegister/CompanyRegister.container';
import EmployeeList from '../containers/EmployeeList/EmployeeList.container';
import EmployeeDetail from '../containers/EmployeeDetail/EmployeeDetail.container';
import EmployeeRegister from '../containers/EmployeeRegister/EmployeeRegister.container';
import EmployeeRoleList from '../containers/EmployeeRoleList/EmployeeRoleList.container';
import EmployeeRoleRegister from '../containers/EmployeeRoleRegister/EmployeeRoleRegister.container';
import EmployeeRoleDetail from '../containers/EmployeeRoleDetail/EmployeeRoleDetail.container';

import organizationRoute from '.';

const { checkPermission } = permissionService;

const companyRouteRead = [
  { path: organizationRoute.COMPANY_LIST, component: CompanyList },
  { path: organizationRoute.COMPANY_LIST_TAB, component: CompanyList },
  { path: organizationRoute.COMPANY_LIST_FILTER, component: CompanyList },
  { path: organizationRoute.COMPANY_DETAIL, component: CompanyDetail },
];
const companyRouteCreate = [
  { path: organizationRoute.COMPANY_REGISTER, component: CompanyRegister },
];
const companyRouteUpdate = [
  { path: organizationRoute.COMPANY_EDIT, component: CompanyRegister },
];

const employeeRouteRead = [
  { path: organizationRoute.EMPLOYEE_LIST, component: EmployeeList },
  { path: organizationRoute.EMPLOYEE_LIST_TAB, component: EmployeeList },
  { path: organizationRoute.EMPLOYEE_LIST_FILTER, component: EmployeeList },
  { path: organizationRoute.EMPLOYEE_DETAIL, component: EmployeeDetail },
];
const employeeRouteCreate = [
  {
    path: organizationRoute.EMPLOYEE_REGISTER,
    component: EmployeeRegister,
  },
];
const employeeRouteUpdate = [
  {
    path: organizationRoute.EMPLOYEE_EDIT,
    component: EmployeeRegister,
  },
];

const roleRouteRead = [
  {
    path: organizationRoute.EMPLOYEE_ROLE_LIST,
    component: EmployeeRoleList,
  },
  {
    path: organizationRoute.EMPLOYEE_ROLE_LIST_FILTER,
    component: EmployeeRoleList,
  },
  {
    path: organizationRoute.EMPLOYEE_ROLE_DETAIL,
    component: EmployeeRoleDetail,
  },
];
const roleRouteCreate = [
  {
    path: organizationRoute.EMPLOYEE_ROLE_REGISTER,
    component: EmployeeRoleRegister,
  },
];
const roleRouteUpdate = [
  {
    path: organizationRoute.EMPLOYEE_ROLE_EDIT,
    component: EmployeeRoleRegister,
  },
];

const OrganizationNavigation = () => [
  ...(checkPermission('Company:read', true) ? companyRouteRead : []),
  ...(checkPermission('Company:create', true) ? companyRouteCreate : []),
  ...(checkPermission('Company:update', true) ? companyRouteUpdate : []),

  ...(checkPermission('Employee:read', true) ? employeeRouteRead : []),
  ...(checkPermission('Employee:create', true) ? employeeRouteCreate : []),
  ...(checkPermission('Employee:update', true) ? employeeRouteUpdate : []),

  ...(checkPermission('Role:read', true) ? roleRouteRead : []),
  ...(checkPermission('Role:read', true) && checkPermission('Role:create', true)
    ? roleRouteCreate
    : []),
  ...(checkPermission('Role:read', true) && checkPermission('Role:update', true)
    ? roleRouteUpdate
    : []),
];

export default OrganizationNavigation;
